import { Suspense, lazy } from "react";
import type { ComponentProps } from "react";
import { MapPlaceholder } from "./MapPlaceholder";

// maplibre-gl весит около 800 КБ. Страницы без карты не должны за него
// платить, поэтому библиотека уезжает в отдельный чанк и грузится
// только там, где карта действительно нужна.
const MapView = lazy(() =>
  import("./MapView").then((m) => ({ default: m.MapView })),
);

export function LazyMap(props: ComponentProps<typeof MapView>) {
  return (
    <Suspense fallback={<MapPlaceholder text="Загрузка карты…" />}>
      <MapView {...props} />
    </Suspense>
  );
}
